import React from 'react';
import { FDRadioGroupInput, FDStack } from '@facet-wealth/design';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import TitleWithRequired from 'Components/ComponentLibrary/Molecules/TitleWithRequired/TitleWithRequired';

const RadioGroupInput = ({
  alignSelf,
  direction,
  error,
  flex,
  flexGrow,
  flexShrink,
  helperTextValue,
  onChange,
  options,
  value,
  label,
  required,
  ...rest
}) => {
  return (
    <FDStack direction={'column'}>
      <TitleWithRequired text={label} required={required} />
      <FDRadioGroupInput
        {...useDataAttrs(rest)}
        direction={direction}
        alignSelf={alignSelf}
        error={error}
        flex={flex}
        flexGrow={flexGrow}
        flexShrink={flexShrink}
        helperText={helperTextValue}
        onChange={onChange}
        options={options}
        value={value}
      />
    </FDStack>
  );
};

RadioGroupInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  direction: 'column',
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  helperTextValue: inputDefaultProps.helperTextValue,
  onChange: inputDefaultProps.onChange,
  value: inputDefaultProps.value,
  required: inputPropTypes.required,
};

RadioGroupInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  direction: PropTypes.oneOf(['row', 'column']),
  error: inputPropTypes.error,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  helperTextValue: inputPropTypes.helperTextValue,
  onChange: inputPropTypes.onChange,
  options: inputPropTypes.options.isRequired,
  value: inputPropTypes.value,
  label: inputPropTypes.label.isRequired,
  required: inputPropTypes.required,
};

export { RadioGroupInput };
